import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { GetWorkflowNode } from '@blaze-shared/workflow-domain';

import { DATASET_SOURCE_ID, WorkflowError } from '../../errors';
import {
  getColumnReferencesFromQueryNode,
  getNamedInputReferencesFromQueryNode,
  getParamReferencesFromQueryNode,
  getTagReferencesFromQueryNode,
} from '../../references/get-references-from-query-node';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';
import { SchemaWithValidationInfo } from '../../validation-context/schema-with-validation-info';
import { validateDataset } from '../_validations/dataset';

@WorkflowNode('Get')
export class GetNode extends BaseWorkflowNode<GetWorkflowNode> {
  static readonly DATASET_SOURCE_ID = DATASET_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return getColumnReferencesFromQueryNode(this.node, schemas);
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return getTagReferencesFromQueryNode(this.node, schemas);
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return getParamReferencesFromQueryNode(this.node, schemas, connectors);
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return getNamedInputReferencesFromQueryNode(this.node, schemas);
  }

  override validate(
    schemas: Map<string | symbol, SchemaWithValidationInfo>,
    connectors: ConnectorInfo[],
  ): WorkflowError<any>[] {
    const errors = super.validate(schemas, connectors);
    return [
      ...errors,
      ...validateDataset(this.workflowId, this.nodeId, this.node.datasetId, schemas),
    ];
  }
}
